export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export function getDeviceType(): DeviceType {
  const width = window.innerWidth;

  if (width < 768) {
    return 'mobile';
  }

  if (width < 1024) {
    return 'tablet';
  }

  return 'desktop';
}

export function getCalendarViewByDevice(): string {
  const deviceType = getDeviceType();

  switch (deviceType) {
    case 'mobile':
      return 'app-calendar-day';
    case 'tablet':
      return 'app-calendar-week';
    case 'desktop':
    default:
      return 'app-calendar-month';
  }
}
